(() => {
    const colSwitchWrapper = document.querySelector('.col-layout-switch-wrapper');
    colSwitchWrapper.addEventListener('click', function(event){
    const parentElem = event.target.closest('.col-layout');
    if(!parentElem || parentElem.classList.contains('active')) return;
        const parentElemLayout = parentElem.getAttribute('data-layout');
        const activeElem = colSwitchWrapper.querySelector('.col-layout.active');
        activeElem ? activeElem.classList.remove('active') : '';
        parentElem.classList.add('active');
        colSwitchWrapper.parentNode.setAttribute('data-selected-layout', parentElemLayout);
        window.sessionStorage.setItem('plp_layout', parentElemLayout);
    });
    const selectedPLPLayout = window.sessionStorage.getItem('plp_layout');
    if(selectedPLPLayout){
        colSwitchWrapper.querySelector('.col-layout[data-layout="'+selectedPLPLayout+'"]').click();
    }
    else{
        colSwitchWrapper.querySelector('.col-layout').click();
    }
    const mobileFilters = document.querySelector('.boost-pfs-filter-toolbar-top-mobile');
    const observer = new IntersectionObserver(() => {
        mobileFilters.classList.toggle('non-sticky');
    }, {
        rootMargin: "0px",
        scrollMargin: "0px",
        threshold: 0.01,
    });

    const targetElem = document.querySelector(".c-collection__header");
    observer.observe(targetElem);
})();